/** Import react/libraries section **/
import React, { useMemo } from 'react';

/** Import resources section **/
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

/** Import helpers section **/
import './CompaniesStyles.scss';

/** Import component section **/
import PageTitle from '../../components/PageTitle';
import FilterBy from '../../components/FilterBy';
import DataTable from '../../components/DataTable';
const CompanyView = ({
  loading,
  companies,
  onFilterBy,
  onAddCompany,
  onEditCompany,
  onDeleteCompany,
  onActiveCompany
}) => {
  const ActionsCell = ({ row }) => {
    return (
      <div className="g-actions-cell">
        <EditIcon
          className="g-row-action-button"
          onClick={() => onEditCompany(row)}
        />
        <Divider orientation="vertical" flexItem />
        <DeleteIcon
          className="g-row-action-button delete"
          onClick={() => onDeleteCompany(row)}
        />
      </div>
    );
  };

  const tableColumns = useMemo(
    () => [
      {
        name: 'id',
        selector: (row) => row?.id,
        sortable: true,
        center: true,
        omit: true
      },
      {
        name: 'Nombre comercial',
        selector: (row) => row?.name,
        sortable: true,
        center: true
      },
      {
        name: '',
        cell: (row) => <ActionsCell row={row} />,
        ignoreRowClick: true,
        grow: 0
      }
    ],
    []
  );

  return (
    <>
      <PageTitle title="Compañías" />
      <Paper className="g-page-header companies_header">
        <div className="companies_header_filterby">
          <FilterBy onChange={onFilterBy} />
        </div>
        <Button onClick={onAddCompany} startIcon={<AddCircleIcon />}>
          Agregar nueva compañía
        </Button>
      </Paper>

      <DataTable data={companies} columns={tableColumns} loading={loading} />
    </>
  );
};

export default CompanyView;
